import moment from 'moment';

export const getReportFileName = disposition => {
  let fileName = `relatorio_${moment().format('YYYYMMDDHHmmss')}.xlsx`; // Nome padrão caso falhe

  if (disposition) {
    // Busca por 'filename=' seguido de algo entre aspas ou até o próximo ponto e vírgula
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);

    if (matches != null && matches[1]) {
      // Remove aspas extras que podem vir na string
      fileName = matches[1].replace(/['"]/g, '');

      // Caso venha no formato UTF-8''nome_do_arquivo, limpamos o prefixo
      if (fileName.toLowerCase().includes("utf-8''")) {
        fileName = decodeURIComponent(fileName.split("utf-8''")[1]);
      }
    }
  }
  return fileName;
};
